<template>
  <div class="login-popup" :class="isPC ? '' : 'login-popup-wap'" @click.stop="stopClick">
    <span class="iconfont icon-cuo" @click="handleClose"></span>
    <div class="switch-bg" v-if="isToggle"></div>
    <div class="login-switch" v-if="isToggle" :class="isSwitch ? '' : 'sms-switch'">
      <div>{{ switchText }}</div>
      <img :src="isSwitch ? codeIcon : computerIcon" @click="handleToggle"/>
    </div>
    <div class="scan-login" v-if="!isSwitch" :key="timers">
      <div class="zh-title">{{ scanZhTitle }}</div>
      <div class="en-title">{{ scanEnTitle }}</div>
      <div id="wx-code"></div>
      <div class="icon-text">
        <span class="iconfont icon-scan"></span>
        <div class="text">
          打开手机
          <div>
            <span>微信</span>扫一扫{{isToggle ? '登录' : ''}}
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-login" v-if="isSwitch" :key="timers">
      <div class="zh-title">短信登录</div>
      <div class="en-title">SIGN IN</div>
      <div class="mobile-div">
        <input placeholder="请输入手机号" v-model="phone"/>
        <span v-if="isGetCode" @click="checkPhone">获取验证码</span>
        <span v-if="!isGetCode">{{ codeTxt }}</span>
      </div>
      <div class="code-div">
        <input placeholder="请输入验证码" v-model="codeNum"/>
      </div>
      <div class="btn-text">未注册手机号，完成验证即可注册并登录</div>
      <div class="btn" @click="handlePhoneLogin">登录</div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import {isPC} from '../../utils/getIsPC'
let codeIcon = require('../../assets/homeImage/login-code.png')
// let computerIcon = require('../../assets/homeImage/login-computer.png')
let computerIcon = require('../../assets/homeImage/login-sms.png')
export default {
  name: 'loginPopup',
  data () {
    return {
      codeIcon,
      computerIcon,
      isSwitch: true,
      isToggle: true,
      switchText: '扫码登录',
      scanZhTitle: '扫码登录',
      scanEnTitle: 'SIGN IN',
      phone: '',
      codeNum: '',
      codeTxt: '',
      isGetCode: true,
      timers: new Date().getTime(),
      isPC: true
    }
  },
  watch: {
    isSwitch (a) {
      this.timers = new Date().getTime()
      if (a) {
        this.switchText = '扫码登录'
      } else {
        this.switchText = '短信登录'
        this.$nextTick(() => {
          let hostArr = window.location.host.split('.')
          let domain = hostArr[hostArr.length - 1]
          new WxLogin({ // eslint-disable-line
            self_redirect: false,
            id: 'wx-code', // 需要显示的容器id
            // appid: process.env.APP_ID, // 公众号appid wx*******
            appid: process.env.APP_ID_SCAN, // 公众号appid wx*******
            scope: 'snsapi_login', // 网页应用只用写 snsapi_login
            // redirect_uri: encodeURIComponent(process.env.Redirect_Course_Uri), // 授权成功后回调的url后端准备的回调地址, 用来接收code
            // redirect_uri: encodeURIComponent(`${process.env.Redirect_Url_Scan_code}?type=2${domainParams}`), // 授权成功后回调的url后端准备的回调地址, 用来接收code
            redirect_uri: encodeURIComponent(`${process.env.Redirect_Url_Scan_code}?type=dfckWebsite&domain=${domain}&routerUrl=${sessionStorage.loginCbRouter}`), // 授权成功后回调的url后端准备的回调地址, 用来接收code
            state: Math.random() * 100,
            style: '',
            // href: "https://www.kindercloud.net/public/wechat_qrcode_login.css" // 外部css文件url，需要https自定义样式链接
            href: 'https://www.kindercloud.net/jump/qrcode.css' // 外部css文件url，需要https自定义样式链接
          })
        })
      }
    }
  },
  created () {
    this.isPC = isPC()
  },
  methods: {
    stopClick () {},
    handleClose () {
      this.Bus.$emit('loginPopup-close')
    },
    handleToggle () {
      this.isSwitch = !this.isSwitch
    },
    checkPhone () {
      let self = this
      if (!/^1[0-9]{10}$/.test(this.phone)) {
        this.$message.error('请输入正确的手机号码')
      } else {
        // self.getCode()
        return new Promise(async (resolve, reject) => {
          try {
            let result = await self.$http.post('/KCSchoolTeacher/DecideMobileExist', {
              Mobile: self.phone,
              KCGroupID: 3
            })
            console.log(result.data, 'sdhsdjsjsdkjds')
            if (result.data) {
              let checkWx = await self.phoneCheckWx()
              if (checkWx.data) {
                await self.getCode()
              } else {
                this.isSwitch = false
                this.isToggle = false
                this.scanZhTitle = '扫码注册'
                this.scanEnTitle = 'Register'
                this.codeNum = ''
                this.phone = ''
                this.isGetCode = true
                this.codeTxt = ''
                this.$message('首次登录请扫码注册')
              }
            } else {
              this.$message.error('该手机号在系统中不存在')
            }
            resolve(result)
          } catch (err) {
            reject(err)
          }
        })
      }
    },
    // 获取验证码
    async getCode () {
      if (!/^1[0-9]{10}$/.test(this.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      let seconds = 60
      let timer
      try {
        await this.$http.get('/WeixinUser/SendPhoneMessage', {
          params: {
            PhoneNO: this.phone,
            KCGroupID: 3
          },
          context: this
        }, {
          showLoader: true
        })
        this.isGetCode = false
        this.codeTxt = `${seconds}s后获取`
        seconds--
        clearInterval(timer)
        timer = setInterval(() => {
          if (seconds > 0) {
            this.codeTxt = `${seconds}s后获取`
            seconds--
          } else {
            this.isGetCode = true
            clearInterval(timer)
          }
        }, 1000)
      } catch (err) {
        console.log(err)
      }
    },
    async ValidPhoneMessage () {
      try {
        let result = await this.$http.get('/WeixinUser/ValidPhoneMessage', {
          params: {
            PhoneNO: this.phone,
            ValidCode: this.codeNum
          },
          context: this
        }, {
          showLoader: true
        })
        return result
      } catch (err) {
        console.log(err)
      }
    },
    async handlePhoneLogin () {
      let self = this
      if (!/^1[0-9]{10}$/.test(this.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      if (!this.codeNum) {
        this.$message.error('请输入验证码')
        return
      }
      let data = await this.ValidPhoneMessage()
      if (!data) {
        return
      }
      return new Promise(async (resolve, reject) => {
        try {
          let result = await self.$http.get('/KCUser/GetUserInfoByMobile', {
            params: {
              Mobile: self.phone
            }
          })
          if (result.data) {
            Cookie.set('UnionID', result.data.UnionID, { expires: 0.5 })
            Cookie.set('NickName', result.data.NickName || '', { expires: 0.5 })
            Cookie.set('headimgurl', result.data.headimgurl || '', { expires: 0.5 })
            this.Bus.$emit('loginSuccessHeader')
          }
          resolve(result)
        } catch (err) {
          reject(err)
        }
      })
    },
    phoneCheckWx () {
      let self = this
      return new Promise(async (resolve, reject) => {
        try {
          let result = await self.$http.get('/KCUser/GetUserInfoByMobile', {
            params: {
              Mobile: self.phone
            }
          })
          // if (result.data) {
          //   Cookie.set('UnionID', result.data.UnionID, { expires: 0.5 })
          //   Cookie.set('NickName', result.data.NickName || '', { expires: 0.5 })
          //   Cookie.set('headimgurl', result.data.headimgurl || '', { expires: 0.5 })
          //   this.Bus.$emit('loginSuccessHeader')
          // } else {
          //   this.isSwitch = false
          //   this.codeNum = ''
          //   this.phone = ''
          //   this.isGetCode = true
          //   this.codeTxt = ''
          //   this.$message('请扫码注册')
          // }
          resolve(result)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.login-popup{
  width: 450px;
  height: 500px;
  padding: 50px 0 0 0;
  position: relative;
  margin: 0 auto;
  //box-shadow: 0 0 30px rgba(0,0,0,0.4);
  //width: 350px;
  max-width: 100%;
  //background-color: white;
  background-image: url("../../assets/homeImage/login-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  .icon-cuo{
    position: absolute;
    top: 5px;
    right: -70px;
    color: #fff;
    margin: 0;
    padding: 0;
    font-size: 36px;
    cursor: pointer;
  }
  .switch-bg{
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #fff;
    border-left: 80px solid transparent;
  }
  .login-switch{
    position: absolute;
    z-index: 2;
    top: 25px;
    right: 12px;
    display: flex;
    div{
      color: #fff;
      background-image: url("../../assets/homeImage/login-border.png");
      background-repeat: no-repeat;
      background-size: cover;
      line-height: 22px;
      font-size: 12px;
      box-sizing: border-box;
      height: 22px;
      padding: 0 20px 0 15px;
      margin-right: 10px;
      white-space: nowrap;
    }
    img{
      height: 40px;
      cursor: pointer;
    }
  }
  .sms-switch{
    right: 20px;
  }
  //.mobile-login scan-login{
  .scan-login{
    display: flex;
    flex-direction: column;
    align-items: center;
    #wx-code{
      margin-top: 50px;
      width: 300px;
      height: 200px;
      //border: 1px solid;
    }
    .icon-text{
      margin-top: 40px;
      display: flex;
      align-items: center;
      .iconfont{
        font-size: 45px;
        margin: 0;
        padding: 0;
        color: #575757;
      }
      .text{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 15px;
        color: #6c6c6c;
        margin-left: 10px;
        &>div{
          margin-top: 10px;
          span{
            color: #cb4600;
          }
        }
      }
    }
  }
  .zh-title{
    font-weight: bold;
    font-size: 24px;
    color: #fff;
    margin-bottom: 10px;
  }
  .en-title{
    font-size: 16px;
    color: rgba(255,255,255,0.5);
  }
  .mobile-login{
    display: flex;
    flex-direction: column;
    align-items: center;
    .mobile-div{
      width: 70%;
      margin-top: 80px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid;
      height: 50px;
      border-bottom: 1px solid #cccccc;
      input{
        height: 50px;
        border: none;
        background: none;
        flex: 1;
      }
      span{
        color: #cb4600;
        font-size: 13px;
        cursor: pointer;
      }
    }
    .code-div{
      width: 70%;
      border-bottom: 1px solid #cccccc;
      height: 50px;
      display: flex;
      align-items: center;
      margin-top: 20px;
      input{
        width: 100%;
        height: 50px;
        border: none;
        background: none;
      }
    }
    input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: #bbbbbb;
    }
    .btn-text{
      width: 70%;
      color: #bbbbbb;
      font-size: 13px;
      margin: 60px 0 10px 0;
    }
    .btn{
      width: 70%;
      line-height: 40px;
      background-color: #cb4600;
      color: #fff;
      text-align: center;
      cursor: pointer;
    }
  }
}
.login-popup-wap{
  width: 85vw;
  height: 400px;
  padding: 40px 0 0 0;
  .icon-cuo{
    left: 5px;
    top: -40px;
  }
  .switch-bg{
    top: 0;
    border-top: 45px solid #fff;
    border-left: 40px solid transparent;
  }
  .login-switch{
    top: 5px;
    right: 12px;
    div{
      margin-right: 0;
    }
    img{
      height: 20px;
    }
  }
  .sms-switch{
    right: 17px;
  }
  .zh-title{
    font-size: 18px;
    margin-bottom: 5px;
  }
  .en-title{
    font-size: 14px;
  }
  .mobile-login{
    .mobile-div{
      margin-top: 20vw;
      width: 85%;
      height: 30px;
      font-size: 14px;
      span{
        font-size: 12px;
        white-space: nowrap;
      }
    }
    .code-div{
      width: 85%;
      height: 30px;
      font-size: 14px;
    }
    .btn-text{
      width: 85%;
      font-size: 12px;
      margin-top: 50px;
    }
    .btn{
      width: 85%;
      line-height: 32px;
      font-size: 15px;
    }
  }
  .scan-login{
    #wx-code{
      margin-top: 8vw;
      width: auto;
      height: auto;
    }
    .icon-text{
      position: absolute;
      bottom: 15px;
      .iconfont{
        font-size: 40px;
      }
      .text{
        margin-left: 5px;
        font-size: 12px;
        div{
          font-size: 13px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/loginPopup.vue